import { Parser } from "@siteimprove/alfa-parser";
import { Function as CSSFunction } from "../../syntax/index.js";
import { Length } from "../numeric/index.js";
import { Value } from "../value.js";
import { Function } from "./function.js";
const { map, filter } = Parser;
/**
 * @public
 */
export class Perspective extends Function {
    static of(depth) {
        return new Perspective(depth);
    }
    _depth;
    constructor(depth) {
        super("perspective", Value.hasCalculation(depth));
        this._depth = depth;
    }
    get depth() {
        return this._depth;
    }
    resolve(resolver) {
        return new Perspective(this._depth.resolve(resolver));
    }
    equals(value) {
        return value instanceof Perspective && value._depth.equals(this._depth);
    }
    hash(hash) {
        hash.writeHashable(this._depth);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            depth: this._depth.toJSON(),
        };
    }
    toString() {
        return `perspective(${this._depth})`;
    }
}
/**
 * @public
 */
(function (Perspective) {
    function isPerspective(value) {
        return value instanceof Perspective;
    }
    Perspective.isPerspective = isPerspective;
    const parseDepth = filter(Length.parse, 
    // {@link https://drafts.csswg.org/css-values/#calc-range}
    (length) => length.hasCalculation() || length.value >= 0, () => "Depth cannot be less than 0");
    /**
     * {@link https://drafts.csswg.org/css-transforms-2/#funcdef-perspective}
     */
    Perspective.parse = map(CSSFunction.parse("perspective", parseDepth), ([_, depth]) => Perspective.of(depth));
    /**
     * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/perspective}
     */
    Perspective.parseProp = map(parseDepth, Perspective.of);
})(Perspective || (Perspective = {}));
//# sourceMappingURL=perspective.js.map